import { PRINT_PROCESS_I18N } from '../data/print-process-i18n'
import Film from './print-process/Film'
import './print-process.css'

/* ==========================================================================
   The print-process band of a service page: the service's station film on
   one plate, looping, with the station title block under its ruler. The
   home page shows all three films side by side (home/HomeServices.jsx).
   Films, timelines and materials live in ./print-process/.
   ========================================================================== */

/**
 * @param {{ lang?: 'tr' | 'en' | 'de', variant?: 'pad' | 'screen' | 'assembly' }} props
 */
export default function PrintProcess({ lang = 'tr', variant = 'pad' }) {
  const variantCopy = PRINT_PROCESS_I18N[variant] ?? PRINT_PROCESS_I18N.pad
  const copy = variantCopy[lang] ?? variantCopy.tr
  const headingId = `pp-${variant}-title`

  return (
    <section className="print-process polymer" data-variant={variant} aria-labelledby={headingId}>
      <div className="container">
        <div className="section-head pp__head">
          <h2 id={headingId}>{copy.title}</h2>
          <p>{copy.lead}</p>
        </div>
        <Film variant={variant} lang={lang} size="plate" labelledBy={headingId} />
      </div>
    </section>
  )
}
